module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faqs"
  }, [(_vm.faqList.length > 0) ? _c('div', {
    staticClass: "current-question"
  }, [(_vm.searchNotInitiated) ? _c('p', [_vm._v(_vm._s(_vm.faqList[_vm.chosenQ].question))]) : _vm._e(), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.faqList[_vm.chosenQ].answer)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "other-questions",
    attrs: {
      "dir": "ltr"
    }
  }, _vm._l((_vm.similarQuestions), function(question) {
    return _c('div', {
      staticClass: "question",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "role": "button",
        "dir": "rtl",
        "tabindex": "0"
      },
      on: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.ChooseFAQ(question)
        },
        "click": function($event) {
          return _vm.ChooseFAQ(question)
        }
      }
    }, [_c('label', {
      staticClass: "question-label",
      attrs: {
        "tabindex": "-1",
        "role": "label"
      }
    }, [_vm._v(_vm._s(question.question))]), _c('br')])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52e5869b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FAQ.vue
// module id = 116
// module chunks = 0